export const calc = {
    ALL: (currentCodeTotal, backupCount) => ({
        ALL: currentCodeTotal,
        DROP_FINISHED: backupCount,
        CANCELED: currentCodeTotal - backupCount,
    }),
    DROP_FINISHED: (currentCodeTotal, backupCount) => ({
        ALL: backupCount,
        DROP_FINISHED: currentCodeTotal,
        CANCELED: backupCount - currentCodeTotal,
    }),
    CANCELED: (currentCodeTotal, backupCount) => ({
        ALL: backupCount,
        DROP_FINISHED: backupCount - currentCodeTotal,
        CANCELED: currentCodeTotal,
    }),
};
